/* global Uint8Array */
// TODO take these exceptions away once we have enough test coverage to catch regressions while fixing these linting errors
/* eslint complexity: "off" , max-depth: "off", max-statements: "off", max-len: "off" */
import $ from 'jquery';
import { inflateRaw } from 'pako';

// BUSAPPS-76319 valid admin redirects for Pendo in app guidance
const validRedirectPaths = [
  '/admin/access/healthinsight',
  '/admin/access/multifactor',
  '/admin/customizations/branding',
  '/admin/getting-started',
  '/reports',
  '/admin/access/policies',
  '/admin/apps/active'
];

const validQueryParams = [
  'pendo'
];

function getAppLink(window, orgUrl) {
  const pattern = /^(https?:\/\/)?([A-Za-z0-9-]{1,63})(\.\S+)/;
  const matches = orgUrl.match(pattern);
  const samlReqest = 'SAMLRequest';
  const relayStateStr = 'RelayState';

  if (matches && matches.length === 4) {
    const url = [];
    url.push(matches[1]);

    const request = getQueryVariable(window.location.search, 'SAMLRequest');
    const relayState = getQueryVariable(window.location.search, 'RelayState');
    const issuer = parseSamlRequest(request);

    if (
      issuer &&
      issuer.toLowerCase().indexOf('corpwebsite') > -1 &&
      matches[3] === '.oktapreview.com'
    ) {
      // if user try to access org in preview or trex, redirect to end user app page instead of sso into corp website
      // as we currently dont support sso into corp website from preview orgs
      return matches[1] + matches[2] + matches[3] + '/app/UserHome';
    } else if (issuer) {
      // If it is a SAML reuqest, with an issuer, get the acs url
      const acsUrl = getSamlAcsUrl(issuer);

      if (acsUrl.toLowerCase().indexOf('/admin/') === 0) {
        url.push(matches[2] + '-admin');
      } else {
        url.push(matches[2]);
      }

      url.push(matches[3]);
      url.push(acsUrl);

      // CIAM workaround
      // SFDC throws error when SAMLRequest sent
      // do not append SAMLRequest or relay state when servicecloud(sfdc) or status or cvent issuer
      // temporary unblock

      let isParam = false;
      if (
        acsUrl &&
        acsUrl.indexOf('servicecloud') < 0 &&
        acsUrl.indexOf('fedramp') < 0 &&
        acsUrl.indexOf('status') < 0 &&
        acsUrl.indexOf('cvent') < 0
      ) {
        url.push(isParam ? '&' : '?');
        isParam = true;
        url.push(samlReqest + '=');
        url.push(encodeURIComponent(request));
      }
      if (relayState) {
        url.push(isParam ? '&' : '?');
        isParam = true;
        url.push(relayStateStr + '=');
        url.push(encodeURIComponent(relayState));
      }
      return url.join('');
    } else if (window.location.pathname === '/oauth2/v1/authorize') {
      return `${orgUrl}${window.location.pathname}${window.location.search}`;
    } else {
      if (matches[2] != 'my') {
        return evaluateTargetPath(window, matches);
      } else {
        return matches[1] + matches[2] + matches[3] + '/user/sso/corpwebsite';
      }
    }
  }
}

function getSamlAcsUrl(issuer) {
  if (issuer && issuer.toLowerCase().indexOf('influitive') > -1) {
    return '/admin/crossorg/sso/ozone';
  } else if (issuer && issuer.toLowerCase().indexOf('torii') > -1) {
    return '/user/sso/torii';
  } else if (issuer && issuer.toLowerCase().indexOf('cornerstone') > -1) {
    return '/user/sso/cornerstone';
  } else if (issuer && issuer.toLowerCase().indexOf('quickmobile') > -1) {
    return '/user/sso/quickmobile';
  } else if (issuer && issuer.toLowerCase().indexOf('cventflex') > -1) {
    return '/user/sso/cventflex';
  } else if (issuer && issuer.toLowerCase().indexOf('cvent') > -1) {
    return '/user/sso/cvent';
  } else if (issuer && issuer.toLowerCase().indexOf('servicecloud') > -1) {
    return '/user/sso/servicecloud';
  } else if (issuer && issuer.toLowerCase().indexOf('status') > -1) {
    return '/admin/crossorg/sso/status';
  } else if (issuer && issuer.toLowerCase().indexOf('devforum') > -1) {
    return '/user/sso/devforum';
  } else if (issuer && issuer.toLowerCase().indexOf('meetingplay') > -1) {
    return '/user/sso/meetingplay';
  } else if (issuer && issuer.toLowerCase().indexOf('fedramp') > -1) {
    return '/user/sso/fedramp';
  } else if (issuer && issuer.toLowerCase().indexOf('oktaciam') > -1) {
    return '/user/sso/oktaciam';
  } else {
    return '/user/sso/corpwebsite';
  }
}

// Use jquery to parse SAML Request XML for IE 9,10,11 compatibility (tested in 10 and 11)
function parseSamlRequest(req) {
  try {
    const decodedReq = zlibDecompress(req);
    const noNamespace = removeXMLNamespaces(decodedReq);
    const xmlDoc = $.parseXML(noNamespace, 'application/xml');
    const $xml = $(xmlDoc);
    const issuer = $.trim($xml.find('Issuer').first().text());
    return issuer;
  } catch (err) {
    return '';
  }
}
// Remove namespaces in SAML before parsing XML
function removeXMLNamespaces(decodedXML) {
  const regex = new RegExp(
    /(<\/?)[a-z_][a-z0-9-_.]*:([a-z_][a-z0-9-_.]*)(>?)/gi
  );
  const noNamespace = decodedXML.replace(regex, '$1$2$3');
  return noNamespace;
}

function zlibDecompress(base64Content) {
  // Convert binary string to character-number array
  var charData = atob(base64Content)
    .split('')
    .map(function (x) {
      return x.charCodeAt(0);
    });
  var decodedData = inflateRaw(new Uint8Array(charData), { to: 'string' });
  return decodedData;
}

function getQueryVariable(path, variable) {
  if (path && variable) {
    var query = path.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      // split at first instance of `=` to support values with `=` signs i.e. redirectPath=/admin/access/healthinsight?pendo=helloWorld
      const param = vars[i].slice(0, vars[i].indexOf('='));
      const value = vars[i].slice(vars[i].indexOf('=') + 1);

      if (decodeURIComponent(param) == variable) {
        return decodeURIComponent(value);
      }
    }
  }
}

function evaluateTargetPath(window, matches) {
  var redirectPath = getQueryVariable(window.location.search, 'redirectPath');
  if (redirectPath) {
    // deep link into the new app instance
    var newAppInstanceMatchTemplate = /\/admin\/app\/[A-Za-z0-9_-]{1,254}\/instance\/_new_\//;
    var matchGroups = redirectPath.match(newAppInstanceMatchTemplate);
    if (matchGroups && matchGroups.length == 1) {
      return computeAdminAppRedirect(matches, redirectPath);
    }

    // deep link into a directory
    var newDirectoryMatchTemplate = /\/admin\/app\/[A-Za-z0-9_-]{1,254}\/intro\/_new_\//;
    matchGroups = redirectPath.match(newDirectoryMatchTemplate);
    if (matchGroups && matchGroups.length == 1) {
      return computeAdminAppRedirect(matches, redirectPath);
    }

    // deep link into specific instance
    var newInstanceMatchTemplate = /\/admin\/app\/[A-Za-z0-9_-]{1,254}\/instance\/[A-Za-z0-9_-]{14,20}$/;
    matchGroups = redirectPath.match(newInstanceMatchTemplate);
    if (matchGroups && matchGroups.length == 1) {
      return computeAdminAppRedirect(matches, redirectPath);
    }
    // mid link into the new idp
    var newIdpMatchTemplate = /\/admin\/access\/identity-providers/;
    matchGroups = redirectPath.match(newIdpMatchTemplate);
    if (matchGroups && matchGroups.length == 1) {
      return computeAdminAppRedirect(matches, redirectPath);
    }

    // deep link into api integration
    var newApiIntegrationTemplate = /\/admin\/integration\/authorize\/[A-Za-z0-9_-]{1,254}$/;
    matchGroups = redirectPath.match(newApiIntegrationTemplate);
    if (matchGroups && matchGroups.length == 1) {
      return computeAdminAppRedirect(matches, redirectPath);
    }

    // deep link into the workflow templates
    let workflowsAppTemplatesMatchTemplate = /(\/workflows)(\/app\/templates\/[a-z0-9_]{1,50}$)/;
    matchGroups = redirectPath.match(workflowsAppTemplatesMatchTemplate);
    if (matchGroups && matchGroups.length === 3) {
      return computeWorkflowRedirect(matches, matchGroups[2]);
    }
    // deep link into the workflow connectors settings
    let workflowsConnectorsMatchTemplate = /(\/workflows)(\/app\/settings\/connections$)/;
    matchGroups = redirectPath.match(workflowsConnectorsMatchTemplate);
    if (matchGroups && matchGroups.length === 3) {
      return computeWorkflowRedirect(matches, matchGroups[2]);
    }

    // deep link into other admin areas, currently supports links from Pendo in app guidance
    const validRedirect = geMatchesForValidRedirectPaths(redirectPath);
    if (validRedirect) {
      return computeAdminAppRedirect(matches, validRedirect);
    }
  }

  return matches[1] + matches[2] + matches[3] + '/app/UserHome';
}

/**
 * Check to see if the redirect path includes an allowlisted redirect and valid query param.
 * Does not need to be an exact match to allow for dynamic values, but
 * it can only have letters and numbers after it valid redirect.
 * Valid:
 *   /admin/access/healthinsight?pendo=123abc
 * Invalid:
 *   /admin/access/healthinsight?pendo=123!adf
 *   /admin/access/healthinsight?pendo=123adf&anotherTHing=123
 **/
function geMatchesForValidRedirectPaths(redirectPath) {
  for (let validRedirectPathRegEx of validRedirectPaths) {
    for (let validQueryParam of validQueryParams) {
      const regex = new RegExp(`(^${validRedirectPathRegEx})([?]${validQueryParam}=[aA-zZ0-9]+)?`);
      const matches = redirectPath.match(regex);
      if (matches && matches[0]) {
        return matches[0];
      }
    }
  }

  return null;
}

function computeAdminAppRedirect(matches, redirectPath) {
  return matches[1] + matches[2] + '-admin' + matches[3] + redirectPath;
}

function computeWorkflowRedirect(matches, workflowPath) {
  return matches[1] + matches[2] + '.workflows' + matches[3] + workflowPath;
}

module.exports = {
  getAppLink,
  getSamlAcsUrl,
  getQueryVariable,
  parseSamlRequest,
  removeXMLNamespaces,
  validRedirectPaths
};



// WEBPACK FOOTER //
// ./lib/saml-redirect-util.js